import styles from "./UserPersonalDetailsCard.module.css"
import React, { useState } from "react";
import cx from 'classnames';
import crossIcon from "../../asset/icons/crossCircle.png"

const countryOptions = [
    { code: '+971', name: 'UAE (AE)' },
    { code: '+965', name: 'Kuwait (KW)' },
    { code: '+966', name: 'Saudi Arabia (SA)' },
    { code: '+968', name: 'Oman (OM)' },
    { code: '+973', name: 'Bahrain (BH)' },
    { code: '+974', name: 'Qatar (QA)' }
];

export const UserPersonalDetailsCard = ({userDetail, handleChange, eraseInput}) => {
    const [selectedCountry, setSelectedCountry] = useState('+971');
    const [localEmail, setLocalEmail] = useState('');
    const [localPhone, setLocalPhone] = useState('');
    
    // Check if currency is USD
    const isUSD = localStorage.getItem('current_currency_type') === 'usd';

    const handleCountryChange = (e) => {
        setSelectedCountry(e.target.value);
    };

    const handleLocalChange = (e) => {
        const { name, value } = e.target;
        if (name === 'email') {
            setLocalEmail(value);
        } else if (name === 'phone') {
            setLocalPhone(value);
        }
        handleChange(e);
    };

    // Use local state for USD, userDetail for non-USD
    const emailValue = isUSD ? localEmail : (userDetail.email || '');
    const phoneValue = isUSD ? localPhone : (userDetail.phone || '');

    return (
        <div className={styles.personalDetailCard}>
            <p className={styles.title}>Personal details</p>
            <div className={styles.inputWrapper}>
                <input className={styles.input}
                    onChange={handleLocalChange}
                    placeholder="Enter Email"
                    name="email"
                    type="email"
                    value={emailValue}
                />
                <img 
                    onClick={eraseInput}
                    name="email"
                    className={emailValue?.length > 0 ? cx(styles.crossSign, styles.display) : styles.crossSign}
                    src={crossIcon} 
                    alt="crossIcon" 
                />
            </div>
            <div className={styles.inputWrapper}>
                {isUSD ? (
                    <select 
                        className={styles.countrySelect}
                        value={selectedCountry}
                        onChange={handleCountryChange}
                    >
                        {countryOptions.map((country) => (
                            <option key={country.code} value={country.code}>
                                {country.name} {country.code}
                            </option>
                        ))}
                    </select>
                ) : (
                    <p className={styles.countryCode}>+91</p>
                )}
                <input 
                    className={cx(styles.input, styles.marginLeft)}
                    onChange={handleLocalChange}
                    name="phone"
                    placeholder="Enter Phone Number"
                    type="number"
                    value={phoneValue}
                    disabled={!isUSD}
                />
            </div>
        </div>
    )
}